var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9297 12.675C29.3547 5.745 23.3097 2.625 17.9997 2.625C17.9997 2.625 17.9997 2.625 17.9847 2.625C12.6897 2.625 6.62965 5.73 5.05465 12.66C3.29965 20.4 8.03966 26.955 12.3297 31.08C13.9197 32.61 15.9597 33.375 17.9997 33.375C20.0397 33.375 22.0797 32.61 23.6547 31.08C27.9447 26.955 32.6847 20.415 30.9297 12.675ZM17.9997 20.19C15.3897 20.19 13.2747 18.075 13.2747 15.465C13.2747 12.855 15.3897 10.74 17.9997 10.74C20.6097 10.74 22.7247 12.855 22.7247 15.465C22.7247 18.075 20.6097 20.19 17.9997 20.19Z",
    fill: "#009b9b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.bb138a6b5e2cf8da56d5a42cb28c7cbf.svg";
export { ForwardRef as ReactComponent };